var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'canvas'),expression:"type === 'canvas'"}],ref:"canvas",style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"height":_vm.size,"width":_vm.size}}),(_vm.type === 'img')?_c('img',{style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"src":_vm.imgData}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }